export default __webpack_public_path__ + "FinSuite-icon.167014f2.svg";